import React from 'react';
import Box from '@mui/material/Box';
import SearchIcon from '@mui/icons-material/Search';
import { MenuItem, Select, OutlinedInput } from '@mui/material';
import styles from '../UsersPage.module.scss';

const orderByFilter = [
  { name: 'All', value: 'all' },
  { name: 'By update date', value: 'updated_at' },
  { name: 'By date', value: 'created_at' },
  { name: 'By status', value: 'status' },
];

const registrationFilter = [
  { name: 'All', value: 'all', query: 'all' },
  {
    name: 'TT invitation',
    value: 'tt_invitation',
    query: {
      column: 'registration_type',
      operator: 'equals',
      filter: 'invited_by_transparenterra',
    },
  },
  {
    name: 'Invitation from a user',
    value: 'invited_by_user',
    query: {
      column: 'registration_type',
      operator: 'equals',
      filter: 'invited_by_user',
    },
  },
  {
    name: 'Uninvited',
    value: 'Uninvited',
    query: {
      column: 'registration_type',
      operator: 'equals',
      filter: 'individual',
    },
  },
];

const statusFilter = [
  { name: 'All', value: 'all', query: 'all' },
  {
    name: 'Blocked',
    value: 'blocked',
    query: {
      column: 'status',
      operator: 'equals',
      filter: 'blocked',
    },
  },
  {
    name: 'Not blocked',
    value: 'not_blocked',
    query: {
      column: 'status',
      operator: 'equals',
      filter: 'not_blocked',
    },
  },
  {
    name: 'Deleted',
    value: 'deleted',
    query: {
      column: 'status',
      operator: 'equals',
      filter: 'deleted',
    },
  },
];

const kycFilter = [
  {
    name: 'All',
    value: 'all',
    query: 'all',
  },
  {
    name: 'Passed',
    value: 'passed',
    query: {
      column: 'kyc',
      operator: 'equals',
      filter: 'success',
    },
  },
  {
    name: 'Created/Pending',
    value: 'created',
    query: {
      column: 'kyc',
      operator: 'is_any_of',
      filter: ['pending', 'created'],
    },
  },
  {
    name: 'Expired/Failure',
    value: 'expired',
    query: {
      column: 'kyc',
      operator: 'is_any_of',
      filter: ['expired', 'failure'],
    },
  },
  {
    name: 'Not passed',
    value: 'not_passed',
    query: {
      column: 'kyc',
      operator: 'is_empty',
    },
  },
];

const Filter = ({ filter, changeFilter, changeOrder, orderBy, searchUser, inputValue }) => (
  <Box className={styles.filters}>
    <div className={styles.searchFilter}>
      <SearchIcon sx={{ color: '#555555' }} className={styles.searchFilterIcon} />
      <OutlinedInput
        value={inputValue}
        className={styles.searchFilterInput}
        placeholder="Search"
        onChange={(e) => searchUser(e.target.value)}
      />
    </div>
    <Select
      displayEmpty
      value={orderBy}
      onChange={(e) => changeOrder(e.target.value)}
      className={styles.filterSelect}
      renderValue={(selected) => {
        if (!selected) {
          return <p className={styles.filterSelectPlaceholder}>Sort by</p>;
        }
        return orderByFilter.find((item) => item.value === selected).name;
      }}
    >
      <MenuItem disabled value="">
        <Box className={styles.menuItem}>Sort by</Box>
      </MenuItem>
      {orderByFilter.map((item) => (
        <MenuItem value={item.value}>
          <Box className={styles.menuItem}>{item.name}</Box>
        </MenuItem>
      ))}
    </Select>
    <Select
      displayEmpty
      value={filter.registration_type}
      onChange={(e) => changeFilter({ ...filter, registration_type: e.target.value })}
      className={styles.filterSelect}
      renderValue={(selected) => {
        if (!selected) {
          return <p className={styles.filterSelectPlaceholder}>Registration</p>;
        }
        return registrationFilter.find((item) => item.query.filter === selected.filter).name;
      }}
    >
      <MenuItem disabled value="">
        <Box className={styles.menuItem}>Registration</Box>
      </MenuItem>
      {registrationFilter.map((item) => (
        <MenuItem value={item.query}>
          <Box className={styles.menuItem}>{item.name}</Box>
        </MenuItem>
      ))}
    </Select>
    <Select
      displayEmpty
      value={filter.status}
      onChange={(e) => changeFilter({ ...filter, status: e.target.value })}
      className={styles.filterSelect}
      renderValue={(selected) => {
        if (!selected) {
          return <p className={styles.filterSelectPlaceholder}>Status</p>;
        }

        return statusFilter.find((item) => item.query.filter === selected.filter).name;
      }}
    >
      <MenuItem disabled value="">
        Status
      </MenuItem>
      {statusFilter.map((item) => (
        <MenuItem value={item.query}>
          <Box className={styles.menuItem}>{item.name}</Box>
        </MenuItem>
      ))}
    </Select>
    <Select
      displayEmpty
      value={filter.kyc}
      onChange={(e) => changeFilter({ ...filter, kyc: e.target.value })}
      className={styles.filterSelect}
      renderValue={(selected) => {
        if (!selected) {
          return <p className={styles.filterSelectPlaceholder}>KYC</p>;
        }

        return kycFilter.find((item) => item.query.filter === selected.filter).name;
      }}
    >
      <MenuItem disabled value="">
        KYC
      </MenuItem>
      {kycFilter.map((item) => (
        <MenuItem value={item.query}>
          <Box className={styles.menuItem}>{item.name}</Box>
        </MenuItem>
      ))}
    </Select>
  </Box>
);

export default Filter;
